import classNames from "classnames";
import { _ } from "../../lib/utils/translate";
import { Icon } from "./Icon";

type FormErrorOrWarningProps = {
  id: string;
  type?: "error" | "warning";
  isVisible?: boolean;
  message?: string;
};

export const FormErrorOrWarning = ({
  id,
  type = "error",
  isVisible,
  message,
}: FormErrorOrWarningProps) => {
  return (
    <div
      id={id}
      role="status"
      className={classNames(
        !isVisible
          ? "sr-only"
          : "mt-1 flex items-center gap-1 font-style-body-xs",
        {
          ["text-danger-2"]: type === "error",
          ["text-warning-2"]: type === "warning",
        }
      )}
    >
      <Icon name="info" size="xsmall" />
      <span className="sr-only">{isVisible && _(`${type}`)}</span>
      <span className="text-gray-1">{message}</span>
    </div>
  );
};
